import { AUTH_QUERY_KEYS } from "./authConstants";
import { persistIdentitySession } from "./authStorage";
import { consumeIntendedRoute } from "./intendedRoute";

const ACCOUNTS_API = process.env.REACT_APP_ACCOUNTS_API_URL || "https://api.accounts.clikkle.com/api";

export function hasIdentityCallback(search = window.location.search) {
  const params = new URLSearchParams(search);
  return Boolean(params.get("userId") || params.get("accessToken") || params.get("refreshToken") || params.get("sessionToken"));
}

async function fetchProfile(userId) {
  const body = new FormData();
  body.append("id", userId);
  const response = await fetch(`${ACCOUNTS_API.replace(/\/$/, "")}/auth/get_user_profile`, { method: "POST", body });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload?.user) throw new Error(payload?.message || "Unable to load the Accounts profile");
  return payload.user;
}

export async function processIdentityCallback() {
  const params = new URLSearchParams(window.location.search);
  const userId = params.get("userId");
  if (!userId) return null;

  const user = await fetchProfile(userId);
  const session = persistIdentitySession({
    user,
    accessToken: params.get("accessToken") || params.get("token") || user?.accessToken || user?.token,
    refreshToken: params.get("refreshToken") || user?.refreshToken,
    sessionToken: params.get("sessionToken") || user?.sessionToken,
  });

  const cleanUrl = new URL(window.location.href);
  AUTH_QUERY_KEYS.forEach((key) => cleanUrl.searchParams.delete(key));
  window.history.replaceState({}, document.title, `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);

  const pendingInvitationToken = localStorage.getItem("pendingInvitationToken");
  const destination = pendingInvitationToken
    ? `/invitation?token=${encodeURIComponent(pendingInvitationToken)}`
    : consumeIntendedRoute("/listOrganization");
  return { user: session, destination };
}
